import { useState } from 'react';
import AdminLayout from './components/AdminLayout';
import Dashboard from './components/Dashboard';
import PropertiesManagement from './components/PropertiesManagement';
import UserManagement from './components/UserManagement';
import SiteSettings from './components/SiteSettings';
import PasswordSettings from './components/PasswordSettings';
import LoginForm from './components/LoginForm';
import { useAuth } from '../../hooks/useAuth';
import LeadsManagementEnhanced from './components/LeadsManagementEnhanced';

export default function AdminPage() {
  const { isAuthenticated, loading } = useAuth();
  const [activeSection, setActiveSection] = useState('dashboard');

  // IMPORTANTE: Mostrar pantalla de carga mientras se verifica la sesión
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 to-blue-100">
        <div className="text-center">
          <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
            <i className="ri-shield-check-line text-3xl text-white"></i>
          </div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Verificando acceso...</h2>
          <p className="text-gray-600">Por favor espere</p>
        </div>
      </div>
    );
  }

  // IMPORTANTE: Solo mostrar LoginForm si NO está autenticado
  if (!isAuthenticated) {
    return <LoginForm />;
  }

  const renderSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <Dashboard onSectionChange={setActiveSection} />;
      case 'properties':
        return <PropertiesManagement />;
      case 'leads':
        return <LeadsManagementEnhanced />;
      case 'users':
        return <UserManagement />;
      case 'settings':
        return <SiteSettings />;
      case 'password':
        return <PasswordSettings />;
      default:
        return <Dashboard onSectionChange={setActiveSection} />;
    }
  };

  return (
    <AdminLayout activeSection={activeSection} onSectionChange={setActiveSection}>
      {renderSection()}
    </AdminLayout>
  );
}
